// extracted by mini-css-extract-plugin
module.exports =  {"splash-page":"ubKWsuSPqnUQUPqCOEEG","splash-page-actions-row":"IAgHbO5FvDFjgX6HYBZK","splash-page-actions-col":"KPzOFUNBD_zmdkg0tMyg"};